import { PrizmLanguageInputLayoutDateTimeRange } from '../../interfaces';

export const PRIZM_ENGLISH_INPUT_LAYOUT_DATE_TIME_RANGE: PrizmLanguageInputLayoutDateTimeRange = {
  inputLayoutDateTimeRange: {
    time: 'Time',
  },
};
